import { Avatar } from '@unifyapps/ui/components/Avatar';
import { Stack } from '@unifyapps/ui/components/Stack';
import { Typography } from '@unifyapps/ui/components/Typography';
import type { NavUserMenu } from '../../../types';

type Props = {
  navItem: NavUserMenu;
};

export function UserItem({ navItem }: Props) {
  const { user } = navItem;

  return (
    <Stack
      className="pe-md gap-md border-tertiary pt-lg ps-xl mt-md flex items-center border-t"
      direction="row"
    >
      <Avatar color="brand_subtle" name={user.name} size="sm" />
      <Typography
        as="span"
        className="ua-side-nav-item-active-false max-w-64"
        color="text-primary"
        maxNumberOfLines={1}
        variant="text-sm"
        weight="semi-bold"
      >
        {user.name}
      </Typography>
    </Stack>
  );
}
